module.exports = __webpack_public_path__ + "assets/dd6939a7124adfabaff26b7800ce3493.png";